import { render } from "./ContentLoader.vue?vue&type=template&id=12b6fc53&scoped=true"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"

import "./ContentLoader.vue?vue&type=style&index=0&id=12b6fc53&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b6fc53"]])

export default __exports__